import $ from 'jquery';
import Region from 'blocks/region/region';

export default class {
	constructor(options) {
		const defaults = {
			el: '#headerRegion',
			dom: {
				toggle: '.js-header-region-toggle',
				region: '.js-region',
				input: '.js-region-input',
				current: '.js-header-region-current'

			},
			classes: {
				state: {
					open: 'b-header-region_state_open'
				}
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$input = this.$el.find(this.options.dom.input);
		this.$document = $(document);
		return this;
	}

	getDom() {
		this.$toggle = this.$el.find(this.options.dom.toggle);
		this.$region = this.$el.find(this.options.dom.region);
		this.$current = $(this.options.dom.current);
		return this;
	}

	onToggle() {
		this.$el.toggleClass(this.options.classes.state.open);
		if (this.$el.hasClass(this.options.classes.state.open)) {
			this.$input.focus();
		}
	}

	open() {
		this.$el.addClass(this.options.classes.state.open);
		this.$input.focus();
	}

	close() {
		this.$el.removeClass(this.options.classes.state.open);
	}

	onDocumentAction(event) {
		const $target = $(event.target);
		if (!$target.is(this.$el) && !$target.closest(this.$el).length && this.$el.hasClass(this.options.classes.state.open)) {
			this.close();
		}
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$toggle.on('click', this.onToggle.bind(this));
			this.region = new Region({el: this.$region}).render();
			this.$document.on('click', this.onDocumentAction.bind(this));
			if (yotaPortlets.region && yotaPortlets.region.name) {
				this.$current.text(yotaPortlets.region.name);
			}
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/partials/site/header/region/region.js